
import { baseClasses } from '@weatherbug/common';
import { PopupStoryResult } from '../../components/common/utilities/newsStoryPopupTypes';

const storyPopupUri = '/api/popups';
const storyPopupKey = 'newsstorypopupkey';
const storyPopupType = 'Story';

const { PulseBaseProvider } = baseClasses;

const getPopupNewsStoryValidationFunction = (result: PopupStoryResult) => {
    return result?.Id && result?.Story?.Title;
};

export class NewsStoryPoupProvider extends PulseBaseProvider {
    constructor(authId?: string, secret?:string, options?: any, logger?: any) {
        super(authId, secret, options, logger);
        window.storage.sync[storyPopupKey] = this.getPopupNewsStorySyncer.bind(this);
    }

    async getPopupNewsStorySyncer(params: any) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const parsedQParams = JSON.parse(id);
        const queryParams = {
            id: parsedQParams.newsStoryPopupId,
            type: parsedQParams.type
        };
        return await super.syncData(key, id, queryParams, storyPopupUri, resolve, reject, getPopupNewsStoryValidationFunction, pulseApi, null, null, false);
    }

    async getPopupNewsStory(newsStoryPopupId: string, type = storyPopupType) {
        const syncParams = {
            newsStoryPopupId,
            type
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(storyPopupKey, id, syncParams);
    }
}
